export const isBrowser = () => typeof window !== "undefined"

export const isStoryblokVisualEditor = () =>
  isBrowser() && window.location !== window.parent.location
